<template>
  <div class="loading-animation-wrapper">
    <div
      v-for="block in blocks"
      :key="block.id"
      class="loading-block"
      :style="{ animationDelay: `${block.delay}ms`, opacity: block.opacity }"
    ></div>
    <h3><slot></slot></h3>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    numBlocks: {
      type: Number,
      default: 40,
    },
    delay: {
      type: Number,
      default: 20,
    },
  },
})
export default class Loading extends Vue {
  numBlocks!: number;
  delay!: number;

  get blocks() {
    const blocks = [];
    for (let id = 0; id < this.numBlocks; id++) {
      let opacity = 1.0;
      if (id <= 3 || id > this.numBlocks - 4) {
        const distance = Math.min(id, this.numBlocks - 1 - id);
        switch (distance) {
          case 0:
            opacity = 0.3;
            break;
          case 1:
            opacity = 0.6;
            break;
          case 2:
            opacity = 0.85;
        }
      }
      const delay = (this.numBlocks - 1 - id) * this.delay;
      blocks.push({ id, delay, opacity });
    }
    return blocks;
  }
}
</script>

<style lang="scss">
@keyframes waveform {
  0% {
    transform: scaleY(0.8725267706415136);
  }
  10% {
    transform: scaleY(0.5977066863297043);
  }
  20% {
    transform: scaleY(1.973453815912041);
  }
  30% {
    transform: scaleY(0.08057453182367103);
  }
  40% {
    transform: scaleY(1.2235050014379312);
  }
  50% {
    transform: scaleY(1.5074329115370009);
  }
  60% {
    transform: scaleY(1.5651015402401098);
  }
  70% {
    transform: scaleY(0.651850403860714);
  }
  80% {
    transform: scaleY(1.0533808948756376);
  }
  90% {
    transform: scaleY(1.0435154560600786);
  }
  100% {
    transform: scaleY(1.442765974533211);
  }
}
.loading-animation-wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  .loading-block {
    animation: waveform linear 1s infinite;
    width: 5px;
    height: 50px;
    border: 1px solid #999;
    background: linear-gradient(180deg, #f0f0f0 0%, #c0c0c0 100%);
  }
  .loading-block:not(:last-child) {
    margin-right: 2px;
  }
  h3 {
    position: absolute;
    width: 100%;
    top: calc(50% - 25px);
    font-size: 38px;
    font-weight: bold;
    margin: 0;
    text-align: center;
  }
}
</style>
